import React from "react";
import GradientButton from "../../../../components/button/Button";
import { HeroImage, V1 } from "../../../../images/Images";
import "./VendorDetailsModal.css";
import PlainButton from "../../../../components/button/PlainButton";
import axiosInstance from "../../../../axiosInstance";

const VendorDetailsModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  vendor: any;
  vendors: any[];
}> = ({ isOpen, onClose, vendor, vendors }) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [success, setSuccess] = React.useState(false);

  if (!isOpen || !vendor) return null;

  const id = vendor?.id || "";
  const logo = vendor?.logo || V1;
  const code = vendor?.store_code || "";
  const description = vendor?.description || "";
  const name = vendor?.name || "";

  // Check if vendor is already in the list
  const isAlreadyAdded = vendors.some((v) => v.venture.id === vendor.id);

  const handleAddVendor = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const res = await axiosInstance.put("/ventures/selections", {
        venture_id: id,
      });
      if (res.data && res.data.valid) {
        setSuccess(true);
        // onClose();
        setTimeout(() => {
          window.location.reload(); // Reload the page to reflect changes
        }, 2000); // Close modal after 2 seconds
      } else {
        setError(res.data?.message || "Failed to add vendor.");
      }
    } catch (err: any) {
      setError("Failed to add vendor.");
    }
    setLoading(false);
  };

  const handleRemoveVendor = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const res = await axiosInstance.put("/ventures/selections", {
        venture_id: id,
      });
      if (res.data && res.data.valid) {
        setSuccess(true);
        // onClose();
        setTimeout(() => {
          window.location.reload(); // Reload the page to reflect changes
        }, 2000); // Close modal after 2 seconds
      } else {
        setError(res.data?.message || "Failed to remove vendor.");
      }
    } catch (err: any) {
      setError("Failed to remove vendor.");
    }
    setLoading(false);
  };

  return (
    <div className="orders-modal">
      <div className="orders-modal__overlay" onClick={onClose}></div>
      <div className="orders-modal__content">
        <div className="orders__modal__header" style={{ marginBottom: 30 }}>
          <h2 className="orders-modal__title">Vendor</h2>
          <button className="orders-modal__close" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="vendor_modal_details">
          <div className="vendor_modal_details_banner">
            <img src={HeroImage} alt="banner" className="banner" />
            <p className="banner-text">{name}</p>
          </div>

          <div className="vendor_modal_image">
            <img src={logo} alt="vendor image" />
          </div>
          <div className="modal_id_cont">
            <p className="vendor_modal_id"> ID: {code}</p>
          </div>
          <p className="vendor_modal_desc">{description}</p>
        </div>

        {error && <div style={{ color: "red", margin: "10px 0" }}>{error}</div>}
        {success && (
          <div
            style={{
              color: isAlreadyAdded ? "#f44336" : "green",
              margin: "10px 0",
            }}
          >
            {isAlreadyAdded
              ? "Vendor removed successfully!"
              : "Vendor added successfully!"}
          </div>
        )}

        <div className="vendors_modal_btn">
          <div className="orders-modal__apply">
            <PlainButton onClick={onClose} text="Cancel" />
          </div>
          <div className="orders-modal__apply ">
            {isAlreadyAdded ? (
              <GradientButton
                onClick={handleRemoveVendor}
                text={loading ? "Removing..." : "Remove Vendor"}
                disabled={loading}
                style={{
                  background: "#f44336",
                  color: "#fff",
                  border: "none",
                  boxShadow: "none",
                }}
              />
            ) : (
              <GradientButton
                onClick={handleAddVendor}
                text={loading ? "Adding..." : "Add Vendor"}
                disabled={loading}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorDetailsModal;
